import './modules/jquery';
import './modules/bootstrap';

import './modules/alert';
import './modules/anchor-links';
import './modules/cookie-notice';
import './modules/default-cookie-banner';
import './modules/external-links';
import './modules/form-validation';
import './modules/header';
import './modules/image-scroller';
import './modules/localization-form';
import './modules/mobile-menu';
import './modules/popup-modal';
import './modules/register-login';
import './modules/sharing-links';
import './modules/table-of-contents';
import './modules/video-player-modal';
